import React, { useEffect, useRef, useState } from 'react';
import './TextField.module.scss';
import { TextField } from '@mui/material';

const MLTextField = ({
  textFieldId = 'outlined-basic',
  placeholder,
  defaultVal,
  label,
  variant = 'standard',
  setTextFieldvalue = () => {},
  handleKeyDown = () => {},
  handleBlur = () => {},
  isDisabled = false,
  autoFocus = false,
  hasError = false,
  isMultiline = false,
  errorText = '',
  classList = '',
  textColourOverride = '',
}) => {
  const [textVal, setTextVal] = useState(defaultVal);

  useEffect(() => {
    if (autoFocus) {
      const textField = document.getElementById(textFieldId);

      if (textField) {
        textField.addEventListener('focus', () => {});

        textField.focus();

        return () => {
          textField.removeEventListener('focus', () => {});
        };
      }
    }
  }, [autoFocus, textFieldId]);

  const handleTextField = (event) => {
    const { value } = event.target;
    setTextVal(value);
  };

  useEffect(() => {
    setTextFieldvalue(textVal);
  }, [textVal, setTextFieldvalue]);

  useEffect(() => {
    setTextVal(defaultVal);
  }, [defaultVal]);

  return (
    <div className="flex flex-col gap-1 flex-1 text-field-wrapper ">
      <TextField
        className={`${classList} text-field-wrap`}
        id={textFieldId}
        autoFocus={autoFocus}
        variant={variant}
        placeholder={placeholder}
        onChange={handleTextField}
        onKeyDown={(event) => handleKeyDown(event)}
        onBlur={(event) => handleBlur(event)}
        value={textVal}
        label={label}
        disabled={isDisabled}
        multiline={isMultiline}
        InputLabelProps={{ shrink: true }}
        sx={{
          '& .MuiInputBase-input.Mui-disabled': {
            WebkitTextFillColor: textColourOverride,
          },
        }}
      />
      {hasError && (
        <span className="text-[var(--Red-100)] text-xs">{errorText}</span>
      )}
    </div>
  );
};

export default MLTextField;
